import { createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.dashboard.url,
        method: API.members.dashboard.method,
      });

      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAdminDashboardData = createAsyncThunk(
  "dashboard/getAdminDashboardData",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.dashboard.url,
        method: API.members.dashboard.method,
      });

      return data?.dashboardData;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
